export const apiUrls = {
  bank: {
    application: '/api/bank/v1/application',
    applicationRevert: '/api/bank/v1/application/revert-to-rfi',
    applicationListWebpages: '/api/bank/v1/webpages/application-list',
    applicationRelatedRecords: '/api/bank/v1/application-related-records',
    applicationAssignOwner: '/api/bank/v1/application/assign-owner',
    applicationRevertToDocumentRequest: '/api/bank/v1/application/revert-to-document-request',
    applicationSubmitDeniedCustomer: '/api/bank/v1/application/submit-denied-customer',
    applicationSubmitApproveDocuments: '/api/bank/v1/application/submit-approve-documents',
    applicationSubmitApprove: '/api/bank/v1/application/submit-approve',
    applicationSendDocumentRequest: '/api/bank/v1/application/send-document-request',
    applicationSetActive: '/api/bank/v1/application-active',
    applicationNotes: '/api/bank/v1/application-notes',
    applicationReview: '/api/bank/v1/application-review',
    applicationDeny: '/api/bank/v1/application-company-denial',

    applicationClientDocument: '/api/bank/v1/application-client-document',
    applicationClientDocumentAccept: '/api/bank/v1/application-client-document/accept',
    applicationClientDocumentReject: '/api/bank/v1/application-client-document/reject',
    applicationClientDocumentFile: '/api/bank/v1/application-client-document-file',
    applicationClientDocumentWebpage: '/api/bank/v1/webpages/application-client-document-details',
    applicationClientDocumentCreateWebpage: '/api/bank/v1/webpages/application-client-document-create-mode',
    applicationClientDocumentEditWebpage: '/api/bank/v1/webpages/application-client-document-edit-mode',
    applicationClientDocumentFileDirectDownload: '/api/bank/v1/application-client-document-file-download',
    applicationClientDocumentFileName: '/api/bank/v1/application-client-document-file-name',
    applicationClientDocumentFileUpload: '/api/bank/v1/application-client-document/file-upload',

    applicationWarningsDetails: '/api/bank/v1/application/warnings-details',
    applicationAcknowledgeWarnings: '/api/bank/v1/application/acknowledge-warnings',

    applicationDocument: '/api/bank/v1/application-document',
    applicationDocumentUpload: '/api/bank/v1/application-document-upload',

    applicationLink: '/api/bank/v1/application-link',
    applicationDetailsViewWebpages: '/api/bank/v1/webpages/application-details-view',

    applicationDocumentDirectDownload: '/api/bank/v1/application-document-direct-download',
    applicationZipDocumentsDownload: '/api/bank/v1/application-zip-documents-download',

    applicationWebPage: '/api/bank/v1/application-get-rfi-form',
    applicationSave: '/api/bank/v1/application-rfi-form',
    applicationSubmitRFI: '/api/bank/v1/application-submit-rfi-form',
    applicationSubmitDocumentRequest: '/api/bank/v1/application/submit-document-request',

    applicationBankAccounts: '/api/bank/v1/webpages/onboarding-bank-accounts',
    applicationSaveBankAccount: '/api/bank/v1/application/save-bank-accounts',
    applicationFinalization: '/api/bank/v1/application/finalize',

    adverseMediaList: '/api/bank/v1/webpages/adverse-media-list',
    adverseMediaCaseClearUnreviewedPublications: '/api/bank/v1/adverse-media-case/clear-unreviewed-publications',
    adverseMediaPublicationReview: '/api/bank/v1/adverse-media-publication/review',
    adverseMediaPublicationUnreview: '/api/bank/v1/adverse-media-publication/unreview',
    adverseMediaPublicationChangeNotes: '/api/bank/v1/adverse-media-publication/change-notes',
    adverseMediaCaseChangeRiskLevel: '/api/bank/v1/adverse-media-case/change-risk-level',
    adverseMediaCaseChangeNotes: '/api/bank/v1/adverse-media-case/change-notes',
    adverseMediaScanResultDownload: '/api/bank/v1/scan-results-download',

    adverseMediaDetailsWebpage: '/api/bank/v1/webpages/adverse-media-details',

    alertsView: '/api/bank/v1/webpages/alerts-view',

    affiliatedCompany: '/api/bank/v1/affiliated-company',

    annualReview: '/api/bank/v1/annual-review',
    annualReviewList: '/api/bank/v1/annual-review-list',
    annualReviewSalesDeposits: '/api/bank/v1/annual-review-sales-deposits',
    annualReviewSalesDepositsEditMode: '/api/bank/v1/annual-review-sales-deposits-edit-mode',
    annualReviewSalesDepositsRecalculation: '/api/bank/v1/annual-review-sales-deposits-recalculation',
    annualReviewDetails: '/api/bank/v1/annual-review-details',
    annualReviewEditMode: '/api/bank/v1/annual-review-edit-mode',
    annualReviewApprove: '/api/bank/v1/annual-review-approve',

    authLogin: '/api/bank/auth/login',
    authLogout: '/api/bank/auth/logout',
    authPassword: '/api/bank/auth/password',
    authPasswordReset: '/api/bank/auth/password-reset',
    authNextcloudCode: '/api/bank/auth/nextcloud/code',
    authMfaDevice: '/api/bank/auth/mfa/device',
    authMfaDeviceDefault: '/api/bank/auth/mfa/device-default',
    authMfaChallenge: '/api/bank/auth/mfa/challenge',
    authMfaLogin: '/api/bank/auth/mfa/login',
    authMfaResetAll: '/api/bank/auth/mfa/all-devices',

    bankAccountSearch: '/api/bank/v1/bank-account-search',

    bankUserListWebpages: '/api/bank/v1/webpages/bank-user-list',

    clientUser: '/api/bank/v1/client-user',
    clientUserCompanies: '/api/bank/v1/client-user-companies',

    cifSubjectSearch: '/api/bank/v1/cif-subject-search',

    company: '/api/bank/v1/company',
    companyEditMode: '/api/bank/v1/company-edit-mode',
    companyCreateMode: '/api/bank/v1/company-create-mode',
    companyListWebpages: '/api/bank/v1/webpages/relationship-list',
    companyUsersAssignment: '/api/bank/v1/company-users-assignment',

    companyDetailsWebpage: '/api/bank/v1/webpages/relationship-details',

    companyAdverseMediaWebpage: '/api/bank/v1/webpages/relationship-details/adverse-media',
    companyDocumentsWebpage: '/api/bank/v1/webpages/relationship-details/documents',
    companyContactsWebpage: '/api/bank/v1/webpages/relationship-details/contacts',
    companyQuarterlyAnalyticsWebpage: '/api/bank/v1/webpages/relationship-details/quarterly-analytics',
    companyAffiliatedCompaniesWebpage: '/api/bank/v1/webpages/relationship-details/affiliated-companies',
    companyLicensesWebpage: '/api/bank/v1/webpages/relationship-details/licenses',
    companyCustomersWebpage: '/api/bank/v1/webpages/relationship-details/customers',
    companyAnnualReviewsWebpage: '/api/bank/v1/webpages/relationship-details/annual-reviews',
    companyBankAccountsWebpage: '/api/bank/v1/webpages/relationship-details/bank-accounts',
    companyVendorsWebpage: '/api/bank/v1/webpages/relationship-details/vendors',
    companyHistoryDetailsWebpage: '/api/bank/v1/webpages/relationship-details/activity-history',
    companyHrr: '/api/bank/v1/webpages/relationship-details/high-risk-review',

    companySearch: '/api/bank/v1/company-search',

    connectionsListWebpages: '/api/bank/v1/connection-list',
    connectionsDetailsWebpages: '/api/bank/v1/connection-details',
    connectionsExport: '/api/bank/v1/connection-list-csv',

    connectionsMetrcCredentials: '/api/bank/v1/metrc-credentials',
    connectionsBioTrackCredentials: '/api/bank/v1/biotrack-credentials',
    connectionsDutchieCredentials: '/api/bank/v1/dutchie-credentials',

    contact: '/api/bank/v1/contact',
    contactSearch: '/api/bank/v1/contact-search',
    contactListWebPage: '/api/bank/v1/webpages/contact-list',
    contactDetailsWebPage: '/api/bank/v1/webpages/contact-details',
    contactEditWebPage: '/api/bank/v1/contact-edit-mode',
    contactCompanyConnection: '/api/bank/v1/contact/company-connection',
    contactCompanyConnectionEditMode: '/api/bank/v1/contact/company-connection-edit-mode',
    contactCompanyConnectionCreateMode: '/api/bank/v1/contact/company-connection-create-mode',

    customerVendorDetails: '/api/bank/v1/customer-vendor-details',

    bsaReportingPage: '/api/bank/v1/webpages/bsa-reporting',
    bsaBatch: '/api/bank/v1/bsa/batch',
    bsaCtrUploadBatchFile: '/api/bank/v1/bsa/ctr/upload-batch-file',
    bsaBatchDetailsWebPage: '/api/bank/v1/webpages/bsa-batch-details',
    batchFileDownload: '/api/bank/v1/bsa/batch-file-download',
    bsaCtr: '/api/bank/v1/bsa/ctr',
    bsaCtrValidate: '/api/bank/v1/bsa/ctr/validate',
    bsaCtrFormBatch: '/api/bank/v1/bsa/ctr/form-batch',
    bsaCtrForm: '/api/bank/v1/bsa/ctr-form',
    bsaCtrApprove: '/api/bank/v1/bsa/ctr/approve',
    bsaCtrCancel: '/api/bank/v1/bsa/ctr/cancel',
    bsaSarTransactionsXls: '/api/bank/v1/bsa/sar-transactions-xls',
    bsaCTRBatchesList: '/api/bank/v1/bsa-ctr-batch-list',

    releaseNotes: '/api/bank/v1/release-notes',

    sar: '/api/bank/v1/bsa/sar',
    sarAcknowledgeWarnings: '/api/bank/v1/bsa-sar-acknowledge-warnings',
    sarList: '/api/bank/v1/bsa/sar-list',
    sarListWebpage: '/api/bank/v1/webpages/bsa-sar-list',
    sarEditMode: '/api/bank/v1/bsa/sar-edit-mode',
    sarCreateMode: '/api/bank/v1/bsa/sar-create-mode',
    sarDetails: '/api/bank/v1/webpages/bsa-sar-details',
    sarFormBatch: '/api/bank/v1/bsa/sar/form-batch',
    sarBatchListWebPage: '/api/bank/v1/webpages/bsa-sar-batch-list',
    editSarPeriod: '/api/bank/v1/bsa/sar-period',
    sarCompany: '/api/bank/v1/bsa/sar-company',
    bsaSarApprove: '/api/bank/v1/bsa/sar/approve',
    bsaSarCancel: '/api/bank/v1/bsa/sar/cancel',
    sarUploadBatchFile: '/api/bank/v1/bsa/sar/upload-batch-file',
    sarRecalculate: '/api/bank/v1/bsa/sar/recalculate',
    sarChangesDetails: '/api/bank/v1/bsa-sar-subjects-info-changes-details',

    portalReport: '/api/bank/v1/portal-report',

    clientPortalUsersActivityReport: '/api/bank/v1/portal-report/companies-with-client-users',
    portalReportCompaniesCSV: '/api/bank/v1/portal-report/companies-with-client-users-csv',
    portalReportSite: '/api/bank/v1/portal-report/compliance-review',
    portalReportSiteCSV: '/api/bank/v1/portal-report/compliance-review-csv',
    portalReportUser: '/api/bank/v1/portal-report/bank-users',
    portalReportUserCSV: '/api/bank/v1/portal-report/bank-users-csv',
    portalReportRelationships: '/api/bank/v1/portal-report/onboarding-relationships-report',
    portalReportRelationshipsCSV: '/api/bank/v1/portal-report/onboarding-relationships-report-csv',
    portalReportApplicationPipeline: '/api/bank/v1/portal-report/application-pipeline',
    portalReportApplicationPipelineCSV: '/api/bank/v1/portal-report/application-pipeline-csv',
    portalReportEmailHistory: '/api/bank/v1/portal-report/client-emails',
    portalReportEmailHistoryCSV: '/api/bank/v1/portal-report/client-emails-csv',
    portalReportAlerts: '/api/bank/v1/portal-report/documents-due',
    portalReportAlertsCSV: '/api/bank/v1/portal-report/documents-due-csv',
    portalReportDocumentStatus: '/api/bank/v1/portal-report/document-status',
    portalReportDocumentStatusCSV: '/api/bank/v1/portal-report/document-status-csv',

    reportFile: '/api/bank/v1/report/file',
    reportFileDownload: '/api/bank/v1/report/file-download',
    reportFileList: '/api/bank/v1/report/file-list',
    reportFileUpload: '/api/bank/v1/report/file-upload',

    ctrEdit: '/api/bank/v1/bsa/ctr-edit-mode',
    ctrListWebpage: '/api/bank/v1/webpages/bsa-ctr-list',
    ctrDetailsWebpage: '/api/bank/v1/webpages/bsa-ctr-details',
    customerList: '/api/bank/v1/customer-list',

    deviceList: '/api/bank/auth/mfa/device-list',

    /* Documents */
    document: '/api/bank/v1/document',
    documentFile: '/api/bank/v1/document-file',
    documentFileUpload: '/api/bank/v1/document-file-upload',
    documentFileDirectDownload: '/api/bank/v1/document-file-direct-download',

    documentPeriod: '/api/bank/v1/document-period',
    documentList: '/api/bank/v1/webpages/document-list-v2',

    documentDetailsPage: '/api/bank/v1/webpages/document-details',
    documentEditPage: '/api/bank/v1/webpages/document-edit-mode',

    manageDocumentPeriod: '/api/bank/v1/document-period-v2',
    documentPeriodDetailsPage: '/api/bank/v1/webpages/document-period-details',
    documentPeriodEditPage: '/api/bank/v1/webpages/document-period-edit-mode',
    // https://swagger.dev.helioscompliance.com/#/document-periods/putDocumentperiodaccept
    documentPeriodApproved: '/api/bank/v1/document-period-accept',
    // https://swagger.dev.helioscompliance.com/#/document-periods/putDocumentperiodincomplete
    documentPeriodIncomplete: '/api/bank/v1/document-period-incomplete',
    // https://swagger.dev.helioscompliance.com/#/document-periods/putDocumentperiodreject
    documentPeriodRejected: '/api/bank/v1/document-period-reject',

    heartbeat: '/api/bank/auth/heartbeat',
    webPageHistoryList: '/api/bank/v1/webpages/history-list',

    internalTransferCancel: '/api/bank/v1/internal-transfer-cancel',
    internalTransfersExport: '/api/bank/v1/internal-transfers-export',
    internalTransfersExportProcess: '/api/bank/v1/internal-transfers-export-process',
    internalTransfersExportFileDirectDownload: '/api/bank/v1/internal-transfers-export-file-direct-download',
    internalTransferWebPage: '/bank/v1/webpages/internal-transfer-list',
    internalTransferDetailsWebPage: '/bank/v1/webpages/internal-transfer-details',

    invoiceSubmittal: '/api/bank/v1/invoice-submittal',
    invoiceSubmittalList: '/api/bank/v1/invoice-submittal-list',
    invoiceSubmittalFileDownload: '/api/bank/v1/invoice-submittal-file-download',
    invoiceSubmittalFileUpload: '/api/bank/v1/invoice-submittal-file-upload',
    invoiceSubmittalFileDelete: '/api/bank/v1/invoice-submittal-file',
    invoiceSubmittalDetails: '/bank/v1/webpages/invoice-submittal-details',
    invoiceSubmittalEditMode: '/bank/v1/webpages/invoice-submittal-edit-mode',

    license: '/api/bank/v1/license',
    licenseDetails: '/api/bank/v1/webpages/license-details',
    licenseEdit: '/api/bank/v1/webpages/license-edit-mode',
    licenseCreate: '/api/bank/v1/webpages/license-create-mode',
    licenseSearch: '/api/bank/v1/license-search',

    organization: '/api/bank/v1/organization',

    parsedTransactions: '/api/bank/v1/bsa/parsed-transactions',
    parsedTransactionsDownload: '/api/bank/v1/bsa/parsed-transactions/download',

    profile: '/api/bank/v1/profile',
    profilePassword: '/api/bank/v1/profile/password',

    reportQuarterly: '/api/bank/v1/report/quarterly',
    reportQuarterlyList: '/api/bank/v1/report/quarterly-list',
    reportQuarterlyAcknowledgeWarnings: '/api/bank/v1/report/quarterly-acknowledge-warnings',
    reportQuarterlyReview: '/api/bank/v1/report/quarterly-review',
    reportQuarterlySaveNotes: '/api/bank/v1/report/quarterly-save-notes',
    quarterlyAnalyticsDetailsWebpage: '/api/bank/v1/webpages/quarterly-analytics-details',
    quarterlyQuestionnaire: '/api/bank/v1/report/quarterly-questionnaire',

    reportMonthly: '/api/bank/v1/report/monthly',
    reportMonthlyList: '/api/bank/v1/report/monthly-list',
    reportMonthlyRecalculate: '/api/bank/v1/report/monthly-recalculate',
    reportMonthlyAcknowledgeWarnings: '/api/bank/v1/report/monthly-acknowledge-warnings',
    reportMonthlyReview: '/api/bank/v1/report/monthly-review',
    reportMonthlySaveNotes: '/api/bank/v1/report/monthly-save-notes',
    reportMonthlyWebPage: '/api/bank/v1/webpages/monthly-analytics-details',

    hrr: '/api/bank/v1/report/custom',
    hrrDetails: '/api/bank/v1/report/custom-details',
    hrrSaveNotes: '/api/bank/v1/report/custom-save-notes',
    hrrSavePeriod: '/api/bank/v1/report/custom-period',
    hrrRecalculate: '/api/bank/v1/report/custom-recalculate',
    hrrAcknowledge: '/api/bank/v1/report/custom-acknowledge-warnings',
    hrrReview: '/api/bank/v1/report/custom-review',
    hrrSave: '/api/bank/v1/report/custom-questionnaire',

    depositsDataBankSource: '/api/bank/v1/deposits-data/bank-source',

    salesDataSourceWebPage: '/api/bank/v1/webpages/sales-data-source-details',
    salesDataBankSource: '/api/bank/v1/sales-data/bank-source',
    salesDataSourceFile: '/api/bank/v1/sales-data/source-file',
    salesDataSourceFileUpload: '/api/bank/v1/sales-data/source-file-upload',
    salesDataSourceFileDownload: '/api/bank/v1/sales-data/source-file-download',
    salesDataClientSourceApprove: '/api/bank/v1/sales-data/client-source-approve',
    salesDataClientSourceReject: '/api/bank/v1/sales-data/client-source-reject',
    salesDataSicsSourceDownloadCSV: '/api/bank/v1/sales-data/sics-source-download-csv',
    salesDataSourceSaveInternalNotes: '/api/bank/v1/sales-data/source-save-internal-notes',
    salesDataSourceSaveRejectionReason: '/api/bank/v1/sales-data/source-save-rejection-reason',
    salesDataClientSourceTaskCancellation: '/api/bank/v1/sales-data/client-source-task-cancellation',
    salesDataClientSourceTaskSending: '/api/bank/v1/sales-data/client-source-task-sending',
    salesDataBankSourceSetupMode: '/api/bank/v1/sales-data/bank-source-setup-mode',

    depositsDataBankSourceSetupMode: '/api/bank/v1/deposits-data/bank-source-setup-mode',

    onboardingDocumentsCreateModeWebPage: '/api/bank/v1/webpages/onboarding-documents-create-mode',
    onboardingDocumentsEditModeWebPage: '/api/bank/v1/webpages/onboarding-documents-edit-mode',
    onboardingDocumentsCloneModeWebPage: '/api/bank/v1/webpages/onboarding-documents-clone-mode',
    createEnvelopeOnboardingDocuments: '/api/bank/v1/document-signing/create-envelope',
    editEnvelopeOnboardingDocuments: '/api/bank/v1/document-signing/update-envelope',
    onboardingDocumentsDetailsWebPage: '/api/bank/v1/webpages/onboarding-documents-details',
    deleteOnboardingDocument: '/api/bank/v1/document-signing/envelope',
    cancelOnboardingDocument: '/api/bank/v1/document-signing/cancel-envelope',
    getOnboardingDocumentSignersList: '/api/bank/v1/document-signing/signers-sync',
    downloadOnboardingDocuments: '/api/bank/v1/document-signing/zip-documents-download',
    sendOnboardingDocuments: '/api/bank/v1/document-signing/send-envelope',
    resendOnboardingDocuments: '/api/bank/v1/document-signing/resend-envelope',

    user: '/api/bank/v1/user',
    userList: '/api/bank/v1/user-list',
    userStatus: '/api/bank/v1/user/active-status',
    userPasswordResetUrl: '/api/bank/v1/user-password-reset-url',
    userAuthPasswordReset: '/api/bank/auth/password-reset',
    authCheckLink: '/api/bank/auth/check-link',

    vendorList: '/api/bank/v1/vendor-list',

    layout: '/api/bank/v1/webpages/bank-portal-layout',
    clientUserList: '/api/bank/v1/webpages/client-users-management',
    createClientUser: '/api/bank/v1/client-user-management/create',
    editClientUser: '/api/bank/v1/client-user-management/edit',
    removeClientUser: '/api/bank/v1/client-user-management/remove',
    sendInviteLinkClientUser: '/api/bank/v1/client-user-management/send-link',

    crbMonitorList: '/api/bank/v1/crb-connection-management',
    crbMonitorSearchLicenses: '/api/bank/v1/crb-connection-management/search-licenses',
    crbMonitorConnect: '/api/bank/v1/crb-connection-management/connect',
    crbMonitorHistory: '/api/bank/v1/crb-connection-management/history',
    crbMonitorDetails: '/api/bank/v1/crb-connection-management/view-details',

    documentTemplateList: '/api/bank/v1/document-template-list',
    documentTemplateDetails: '/api/bank/v1/document-template-details',
    documentTemplateCreate: '/api/bank/v1/document-template-create-mode',
    documentTemplateEdit: '/api/bank/v1/document-template-edit-mode',
    documentTemplate: '/api/bank/v1/document-template',
    documentTemplateActivate: '/api/bank/v1/document-template-activate',
    documentTemplateDeactivate: '/api/bank/v1/document-template-deactivate',
    documentTemplateExportCSV: '/api/bank/v1/document-template-export-csv',

    globalSearch: '/api/bank/v1/global-search-list',

    feedback: '/api/bank/v1/feedback'
  },
  client: {
    applicationSave: '/api/client/v1/application-rfi-form',
    applicationDocumentRequestAcknowledge: '/api/client/v1/application-document-request-acknowledge',
    applicationDocumentDirectDownload: '/api/client/v1/application-document-direct-download',
    applicationDocumentUpload: '/api/client/v1/application-document-upload',
    applicationDocument: '/api/client/v1/application-document',
    applicationWebPage: '/api/client/v1/webpages/onboarding',
    applicationSaveClientNotes: '/api/client/v1/application-notes',
    applicationSubmitRFI: '/api/client/v1/application-submit-rfi-form',
    applicationDocumentsSubmit: '/api/client/v1/application-submit-document-request',

    authLogin: '/api/client/auth/login',
    authLogout: '/api/client/auth/logout',
    authPassword: '/api/client/auth/password',
    authPasswordReset: '/api/client/auth/password-reset',
    authApplicationTokenValidate: '/api/client/auth/application-token-validate',
    authMfaDevice: '/api/client/auth/mfa/device',
    authMfaDeviceDefault: '/api/client/auth/mfa/device-default',
    authMfaChallenge: '/api/client/auth/mfa/challenge',
    authMfaLogin: '/api/client/auth/mfa/login',
    authCheckLink: '/api/client/auth/check-link',

    bioTrackCredentials: '/api/client/v1/biotrack-credentials',
    bioTrackCredentialsList: '/api/client/v1/biotrack-credentials-list',

    clientUser: '/api/client/v1/client-user',
    clientUserEmail: '/api/client/v1/client-user-email',
    clientUserList: `/api/client/v1/client-user-list`,
    clientUserCompanies: '/api/client/v1/client-user-companies',
    clientUserPermissions: '/api/client/v1/client-user-permissions',
    clientUserPermissionsCreate: '/api/client/v1/client-user-permissions-create-mode',
    clientAcceptTerms: '/api/client/v1/accept-terms',

    deviceList: '/api/client/auth/mfa/device-list',

    documentFile: '/api/client/v1/document-file',
    documentFileUpload: '/api/client/v1/document-file-upload',
    documentFileDirectDownload: '/api/client/v1/document-file-direct-download',

    applicationClientDocumentFileDirectDownload: '/api/client/v1/application-client-document-file-download',
    applicationClientDocumentFileUpload: '/api/client/v1/application-client-document-file-upload',
    applicationClientDocumentFile: '/api/client/v1/application-client-document-file',

    internalTransfer: '/api/client/v1/internal-transfer',
    internalTransferHistory: `/api/client/v1/internal-transfer-history`,

    internalTransferApprove: '/api/client/v1/internal-transfer-approve',
    internalTransferCancel: '/api/client/v1/internal-transfer-cancel',
    internalTransferSetting: '/api/client/v1/internal-transfer-setting',

    internalTransferListWebPage: '/api/client/v1/webpages/internal-transfer-list',
    internalTransferCreateWebPage: '/api/client/v1//webpages/internal-transfers-create-mode',

    invoiceSubmittal: '/api/client/v1/invoice-submittal',
    invoiceSubmittalListV2: `/api/client/v1/invoice-submittal-list-v2`,
    invoiceSubmittalCreateMode: `/api/client/v1/invoice-submittal-create-mode`,
    invoiceSubmittalFileDownload: '/api/client/v1/invoice-submittal-file-download',
    invoiceSubmittalFileUpload: '/api/client/v1/invoice-submittal-file-upload',

    heartbeat: '/api/client/auth/heartbeat',

    monthlyReport: '/api/client/v1/client-sales-data',
    monthlyReportFile: '/api/client/v1/client-sales-data-file-upload',

    organizationList: '/api/client/v1/organization-list',

    profilePassword: '/api/client/v1/profile/password',

    taskList: '/api/client/v1/task-list',
    tasksListWebPage: '/api/client/v1/webpages/tasks-list',

    metrcCredentials: '/api/client/v1/metrc-credentials',
    metrcCredentialsList: '/api/client/v1/metrc-credentials-list',

    layout: '/api/client/v1/webpages/client-portal-layout'
  },
  support: {
    authLogin: '/api/support/auth/login',
    authLogout: '/api/support/auth/logout',
    authPassword: '/api/support/auth/password',
    authPasswordReset: '/api/support/auth/password-reset',
    authMfaDevice: '/api/support/auth/mfa/device',
    authMfaDeviceDefault: '/api/support/auth/mfa/device-default',
    authMfaChallenge: '/api/support/auth/mfa/challenge',
    authMfaLogin: '/api/support/auth/mfa/login',

    clientPortalReport: '/api/support/v1/client-portal-report',
    clientPortalReportCsv: '/api/support/v1/client-portal-report-csv',

    licensesWithBankAccountsReport: '/api/support/v1/portal-report/licenses-with-bank-accounts-report',
    licensesWithBankAccountsReportCsv: '/api/support/v1/portal-report/licenses-with-bank-accounts-report-csv',

    documentTemplatesReport: '/api/support/v1/portal-report/document-templates',
    documentTemplatesReportCsv: '/api/support/v1/portal-report/document-templates-csv',

    relationshipsDuplicateReport: '/api/support/v1/portal-report/relationships-duplicate-report',
    relationshipsDuplicateReportCsv: '/api/support/v1/portal-report/relationships-duplicate-report-csv',

    deviceList: '/api/support/auth/mfa/device-list',

    heartbeat: '/api/support/auth/heartbeat',

    profile: '/api/support/v1/profile',
    profilePassword: '/api/support/v1/profile/password',

    statisticsTable: '/api/support/v1/statistics-table',
    setupDocumentTemplate: '/api/support/v1/document-templates/setup',
    validateDocumentTemplate: '/api/support/v1/document-templates/validate',

    importDocusignTemplatesFile: '/api/support/v1/docusign-templates/import',

    uploadBSAForm: '/api/support/v1/bsa-reports/upload',
    fileBrowser: '/api/support/v1/file-browser/browse',
    fileBrowserDownload: '/api/support/v1/file-browser/file-download',

    feedbackReport: '/api/support/v1/feedback-report',
    feedbackReportCsv: '/api/support/v1/feedback-report-csv'
  }
} as const
